module.exports = __webpack_public_path__ + "img/pause.be4bd190.svg";